


































































import mixins from 'vue-typed-mixins'
import Navigation from '@/calendesk/mixins/Navigation'
import LoggedUserMenu from '@/calendesk/sections/navbar/components/LoggedUserMenu.vue'
import AdditionalPagesMenu from '@/calendesk/sections/navbar/components/AdditionalPagesMenu.vue'
export default mixins(Navigation).extend({
  name: 'Navbar2',
  components: { AdditionalPagesMenu, LoggedUserMenu }
})
